import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { getUploadUrl } from "../../services/actions";

const FileUploader = ({ onChange = () => {}, value } ) => {
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const uploadRef = useRef();
  const statusRef = useRef();
  const progressRef = useRef();

  const handleFile = () => {
    setFile(uploadRef.current.files[0]);
  };

  useEffect(() => {
    if (file) {
      setLoading(true)
      uploadToPresignedUrl();
    }
  }, [file])


  const uploadToPresignedUrl = async () => {
    try {
      const response = await getUploadUrl(file.name);
      const { upload_url, public_url } = response;
      const uploadResponse = await axios.put(upload_url, file, { onUploadProgress: ProgressHandler });
      onChange(public_url)
    } catch (error) {
      statusRef.current.innerHTML = "Error uploading file";
      console.error("Error uploading file:", error);
    }
    setLoading(false)
  };

  const ProgressHandler = (e) => {
    let percent = Math.round((e.loaded / e.total) * 100);
    progressRef.current.value = percent;
    statusRef.current.innerHTML = percent + "%";
  };

  return (
    <div>
      <input type="file" name="file" ref={uploadRef} onChange={handleFile} disabled={loading}/>
      {file && loading && <label>
        <span ref={statusRef}> </span>
        <progress ref={progressRef} value="0" max="100"/>
      </label>}
    </div>
  );
};

export default FileUploader;
